(function() {
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfClearInvalidSelection', [
    '$parse', function($parse) {
      return {
        restrict: 'A',
        require: 'uiSelect',
        link: (function(_this) {
          return function(scope, element, attrs) {
            var array_name, dontClearFn, junk, prop, ref, repeat_attr;
            repeat_attr = $(element.find('.ui-select-choices')[0]).attr('repeat');
            ref = repeat_attr.match(/\s+in\s+(\S+)/), junk = ref[0], array_name = ref[1];
            prop = attrs.mfClearInvalidSelection;
            if (attrs.dontClearIf) {
              dontClearFn = $parse(attrs.dontClearIf);
            }
            if (prop != null) {
              return scope.$parent.$watchCollection(array_name, function(items) {
                var match, ref1, selected;
                if (typeof dontClearFn === "function" ? dontClearFn(scope.$parent) : void 0) {
                  return;
                }
                selected = (ref1 = scope.$select.selected) != null ? ref1[prop] : void 0;
                match = _.filter(items, function(item) {
                  return item[prop] === selected;
                })[0];
                if ((match == null) || match !== scope.$select.selected) {
                  return scope.$select.select(match != null ? match : null);
                }
              });
            } else {
              return scope.$parent.$watchCollection(array_name, function(items) {
                var ref1;
                if (typeof dontClearFn === "function" ? dontClearFn(scope.$parent) : void 0) {
                  return;
                }
                if (ref1 = scope.$select.selected, indexOf.call(items, ref1) < 0) {
                  return scope.$select.select(null);
                }
              });
            }
          };
        })(this)
      };
    }
  ]);

}).call(this);
